import React from 'react';
import Layout from '../../../components/Layout/Layout';
import { Col, Row, Typography } from 'antd';
import useQuizPreview from './useQuizPreview';
import TextArea from '../components/Textarea/Textarea';
import SelectSingle from '../components/SelectSingle/SelectSingle';
import SelectMultiple from '../components/SelectMultiple/SelectMultiple';
import { useParams } from 'react-router-dom';
import './QuizPreview.scss';
import FlatTitle from '../../LandingPage/components/ContactUs/components/FlatTitle';


const QuizPreview = () => {
    const { id } = useParams()

    const {
        questions,
        getQuestionData,
        quizName,
        selectedCourse,
    } = useQuizPreview(id)


    return (
        <div className="quiz-preview" pageName="Quiz Preview">
             <FlatTitle pageName={"Quiz Preview"} />
             <div className="section-container">
           <div id="wrapper">
            <Row justify="end" align="bottom" gutter={16}>
                <Col span={4}></Col>
                <Col span={8}><Typography.Title level={4}>Quiz : {quizName}</Typography.Title></Col>
                <Col span={8}><Typography.Title level={4}>Course : {selectedCourse}</Typography.Title></Col>
                <Col span={4}></Col>
            </Row>
            
            <Row justify="end" align="bottom" gutter={16}  >
                <Col span={24} >
                    {
                        questions?.map((question, index) => {
                            if (question.typeOfQuestion === "Textarea") {
                                return <TextArea  questionNumber={index} getData={getQuestionData} data={question} operation="preview"/>
                            }
                            else if (question.typeOfQuestion === "SelectSingle") {
                                return (<SelectSingle  questionNumber={index} getData={getQuestionData} data={question} operation="preview"/>)
                            } else if (question.typeOfQuestion === "SelectMultiple") {
                                return (<SelectMultiple  questionNumber={index}   data={question} operation="preview"/>)
                            }
                        })
                    }
                </Col>
            </Row>
            </div>
            </div>
        </div>
    );
};

export default QuizPreview;